import petsGuide from "./Guides/petsGuide";
import GuideRenderer from "../../components/wikiComponents/GuideRenderer";

const PetsGuide = () => {
  return <GuideRenderer url="pets" guideData={petsGuide} />;
};

export default PetsGuide;
